import { TableRow } from '@material-ui/core';
import React, { FC, memo, ReactNode } from 'react';

const noop = () => undefined;

interface Props {
  children: ReactNode;
  onClick?: () => void;
  hover?: boolean;
}

export const MuiTableRow: FC<Props> = memo(
  ({ children, onClick = noop, hover = true }: Readonly<Props>) => (
    <TableRow
      onClick={onClick}
      hover={hover}
      style={{ cursor: onClick === noop ? 'default' : 'pointer' }}
    >
      {children}
    </TableRow>
  )
);

MuiTableRow.displayName = 'MuiTableRow';
